<template>
  <div class="w-screen bg-black fill-primary-white text-white">
    <BaseContainer>
      <div class="hidden md:grid py-[60px] grid-cols-2 gap-x-[100px]">
        <div class="flex flex-col items-start">
          <div class="flex flex-col">
            <NuxtLinkLocale to="/" aria-label="Home Page">
              <SvgCaseClubLogo class="w-[200px] h-[24px]" />
            </NuxtLinkLocale>
            <div class="mt-6">© 2023 All rights reserved.</div>
          </div>
          <div class="mt-auto flex gap-x-6">
            <a
              v-for="item in social"
              :key="item.url"
              target="_blank"
              :href="item.url"
              :aria-label="item.alt"
            >
              <img
                :alt="item.alt"
                class="w-8 h-8 object-contain hover:opacity-50"
                :src="item.imageUrl"
            /></a>
          </div>
        </div>
        <div class="grid grid-cols-3">
          <div
            v-for="(group, index) in menu"
            :key="group.group"
            class="flex flex-col"
          >
            <div class="text-2xl mb-4">{{ $t(group.group) }}</div>
            <div class="flex flex-col space-y-2">
              <NuxtLinkLocale
                v-for="item in group.subMenu"
                :key="item.title"
                :to="item.url"
                :class="twJoin('hover:opacity-50')"
                >{{ $t(item.title) }}</NuxtLinkLocale
              >
              <div
                v-if="index == menu.length - 1"
                class="!mt-6 flex flex-col space-y-2"
              >
                <NuxtLinkLocale
                  v-for="item in fixedMenu"
                  :key="item.title"
                  :to="item.url"
                  :class="twJoin('hover:opacity-50')"
                  >{{ $t(item.title) }}</NuxtLinkLocale
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block md:hidden">
        <div class="py-14">
          <NuxtLinkLocale to="/" aria-label="Home Page">
            <SvgCaseClubLogo class="w-[200px] h-[24px]" />
          </NuxtLinkLocale>
          <div class="mt-6">
            {{ $t('footer.description') }}
          </div>
          <div>
            <div
              v-for="(group, index) in menu"
              :key="group.group"
              class="flex flex-col"
            >
              <div
                :class="
                  twJoin(
                    'text-2xl flex items-center justify-between py-4 cursor-pointer hover:opacity-50 border-dashed border-b border-border-divider',
                    submenu == group.group && 'border-none'
                  )
                "
                @click="submenu = submenu == group.group ? '' : group.group"
              >
                <div>{{ $t(group.group) }}</div>
                <Icon v-if="submenu == group.group" name="minus" />
                <Icon v-if="submenu != group.group" name="plus" />
              </div>
              <div
                v-if="submenu == group.group"
                class="flex flex-col space-y-4 pb-4 border-dashed border-b border-border-divider"
              >
                <NuxtLinkLocale
                  v-for="item in group.subMenu"
                  :key="item.title"
                  :to="item.url"
                  :class="twJoin('hover:opacity-50')"
                >
                  {{ $t(item.title) }}
                </NuxtLinkLocale>
              </div>
              <div
                v-if="index == menu.length - 1"
                class="!mt-4 flex flex-col space-y-2"
              >
                <NuxtLinkLocale
                  v-for="item in fixedMenu"
                  :key="item.title"
                  :to="item.url"
                  :class="twJoin('hover:opacity-50')"
                  >{{ $t(item.title) }}</NuxtLinkLocale
                >
              </div>
            </div>
          </div>
          <div class="mt-10">
            <div class="mt-auto flex gap-x-6">
              <a
                v-for="item in social"
                :key="item.url"
                target="_blank"
                :href="item.url"
                :aria-label="item.alt"
              >
                <img
                  :alt="item.alt"
                  class="w-12 h-12 object-contain hover:opacity-50"
                  :src="item.imageUrl"
              /></a>
            </div>
          </div>
          <div class="mt-4">© 2023 All rights reserved.</div>
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
const menu = [
  {
    group: 'footer.groupShop',
    subMenu: [
      {
        title: 'footer.subDevices',
        url: '/devices'
      },
      {
        title: 'footer.subStyles',
        url: '/all-styles'
      },
      {
        title: 'footer.subCollabs',
        url: '/collabs'
      },
      {
        title: 'footer.subPersonalization',
        url: '/personalization'
      },
      {
        title: 'footer.subProducts',
        url: '/products'
      },
      {
        title: 'pages.blogs.expore',
        url: '/blogs'
      }
    ]
  },
  {
    group: 'footer.groupAbout',
    subMenu: [
      {
        title: 'footer.subAboutUs',
        url: '/about-us'
      }
      // {
      //   title: 'Careers',
      //   url: '/careers'
      // }
    ]
  },
  {
    group: 'footer.groupHelp',
    subMenu: [
      {
        title: 'footer.subFaqs',
        url: '/faqs'
      },
      {
        title: 'footer.subMyorder',
        url: '/account/my-orders'
      },
      {
        title: 'footer.subVisit',
        url: '/visit-us'
      }
    ]
  }
]

const fixedMenu = [
  {
    title: 'footer.subPolicy',
    url: '/privacy-policy',
    separator: true
  },
  {
    title: 'footer.subTerm',
    url: '/terms-and-conditions'
  }
]

const social = [
  {
    alt: 'facebook',
    imageUrl: '/images/social/facebook.svg',
    url: 'https://www.facebook.com/profile.php?id=61556886332382'
  },
  {
    alt: 'instagram',
    imageUrl: '/images/social/instagram.svg',
    url: 'https://www.instagram.com/caseclub_official/'
  },
  {
    alt: 'tiktok',
    imageUrl: '/images/social/tiktok.svg',
    url: 'https://www.tiktok.com/@caseclub_official'
  }
]

const submenu = ref<string>('')
</script>
